import React from 'react';
import PropTypes from 'prop-types';
import { Responsive as ReactGrid, WidthProvider } from 'react-grid-layout';
import ImmutablePropTypes from 'react-immutable-proptypes';

const ResponsiveReactGrid = WidthProvider(ReactGrid);

// import WaitingCalls from './WaitingCalls';
// import WaitingChats from './WaitingChats';
// import HotBets from './HotBets';
// import LargeBets from './LargeBets';
// import LastViewed from './LastViewed';
// import LatestActivity from './LatestActivity';
// import PopularEvents from './PopularEvents';
// import SuspiciousBets from './SuspiciousBets';
// import TodaysRacing from './TodaysRacing';
// import Watchlist from './Watchlist';
import LiabilityLimits from './LiabilityLimits';
import Multiples from './Multiples';

import AvgNetPayout from './AvgNetPayout';
import LastLegRum from './LastLegRum';

const BOXES = [
    LiabilityLimits,
    Multiples,
    AvgNetPayout,
    LastLegRum,
    // WaitingCalls,
    // WaitingChats,
    // HotBets,
    // LargeBets,
    // LastViewed,
    // LatestActivity,
    // PopularEvents,
    // SuspiciousBets,
    // TodaysRacing,
    // Watchlist
];

class DashboardGrid extends React.Component {
    static propTypes = {
        getWidgetSettings: PropTypes.func.isRequired,
        routes: ImmutablePropTypes.map.isRequired
    };

    static defaultProps = {
        rowHeight: 20,
        columns: {
            lg: '12',
            md: '10',
            sm: '6',
            xs: '4',
            xxs: '2'
        }
    };

    constructor(props, context) {
        super(props, context);

        this.layout = this.getLayout();

        this.state = {
            layouts: {
                lg: this.layout
            },
            currentBreakpoint: 'lg'
        };
    }

    getLayout() {
        return BOXES.map((Box, key) => {
            return {
                x: Box.X,
                y: Box.Y,
                w: Box.WIDTH,
                h: Box.HEIGHT,
                i: '' + key,
                'static': Box.STATIC
            };
        });
    }

    generateDOM() {
        const { stopTick } = this.state;

        return BOXES.map((Box, key) => {
            return (
                <div key={key}>
                    <Box static={ Box.STATIC } stopTick={ stopTick } />
                </div>
            );
        });
    }

    componentDidMount() {
        this.props.getWidgetSettings();
    }

    UNSAFE_componentWillReceiveProps(props) {
        if ( props.routes !== this.props.routes ) {
            this.setState({
                stopTick: !!props.routes.get('customers')
            });
        }
    }

    render() {
        return (
            <div>
                <ResponsiveReactGrid
                    layouts={ this.state.layouts }
                    onResize={ () => this.forceUpdate() }
                    useCSSTransforms={ true }
                    isResizable={ true }
                    {...this.props}>
                    {this.generateDOM()}
                </ResponsiveReactGrid>
            </div>
        );
    }
}

export default DashboardGrid;
